import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import loadable from '@loadable/component'

// Components
// import Header from '../header'
// import Footer from '../footer'
// import SEO from '../seo'

// Loadable components
const Header = loadable(() => import('../header/Header'))
const Footer = loadable(() => import('../footer/Footer'))
const SEO = loadable(() => import('../seo/SEO'))

const Layout = (props) => {
  // console.log('👾 Layout', props)
  return (
    <>
      <CssBaseline />
      <SEO />
      <Header {...props} />
      <main>{props.children}</main>
      <Footer {...props} />
    </>
  )
}

export default Layout
